import PageTitle from "../../../../components/PageTitle/PageTitle";
import { useEffect, useState } from "react";
import TemplatesList from "./listing";
import { useUserState } from "../../../../context/UserContext";
import env from "../../../../env.json";
import axios from "axios";
import { Grid } from "@material-ui/core";
import DeleteModal from "../../../../components/DeleteModal/DeleteModal";
import Add from "./add";
import UserPopover from "../../../../components/Popover/UserPopover";
import { Button, Pagination } from "@mui/material";
import TemplateModal from "./modal";
import "./style.css";
import UserSnackbar from "../../../../components/Snackbar.js/UserSnackbar";

export default function TemplatePayment() {
  const { token } = useUserState();
  const [templateList, setTamplateList] = useState([]);
  const [getTamplateId, setGetTamplateId] = useState(null);
  const [deleteDone, setDeleteDone] = useState(false);
  const [openDeleteModal, setOpenDeleteModal] = useState(false);
  const [openModal, setOpenModal] = useState(false);
  const [popoverEvent, setPopoverEvent] = useState(null);
  const [popoverDeps, setPopoverDeps] = useState(false);
  const [isEdit, setIsEdit] = useState(false);
  const [editTemplate, setEditTemplate] = useState(null);
  const [openSnackbar, setOpenSnackbar] = useState(false);
  const [snackbarMsg, setSnackbarMsg] = useState(null);
  const [snackbarSeverity, setSnackbarSeverity] = useState(null);

  const open = Boolean(popoverEvent);
  const id = open ? "popover-textfield" : undefined;

  useEffect(() => {
    getClientsFunc();

    if (!popoverDeps) {
      setPopoverEvent(null);
      setIsEdit(false);
    }

    if (deleteDone) {
      const request = {
        url: env.BaseURL + `api/user/payment/tamplate`,
        method: "DELETE",
        headers: {
          Authorization: `Bearer ${token}`,
          "Content-Type": "application/json",
        },
        data: {
          id: getTamplateId,
        },
      };
      axios(request)
        .then((res) => {
          setOpenDeleteModal(false);
          setGetTamplateId(null);
          setOpenModal(false);
          setDeleteDone(false);
          getClientsFunc();
        })
        .catch((err) => {
          console.log(err);
        });
    }
  }, [deleteDone, popoverDeps]);

  useEffect(() => {
    if (!isEdit) {
      setEditTemplate(null);
    } else {
      setEditTemplate(
        templateList.find((val) => val.temp_id === getTamplateId),
      );
    }
  }, [isEdit]);

  const getClientsFunc = () => {
    const requestClients = {
      url: env.BaseURL + `api/user/payment/tamplate`,
      method: "GET",
      headers: {
        Authorization: `Bearer ${token}`,
        "Content-Type": "application/json",
      },
    };
    axios(requestClients)
      .then((response) => {
        if (response.data.status === 200) {
          setTamplateList(response.data.data);
        } else {
          setTamplateList([]);
        }
      })
      .catch((error) => {
        console.error(error);
      });
  };

  const templateForm = (
    <Add
      data={editTemplate}
      setOpen={setPopoverDeps}
      setOpenSnackbar={setOpenSnackbar}
      setSnackbarSeverity={setSnackbarSeverity}
      setSnackbarMsg={setSnackbarMsg}
    />
  );

  return (
    <>
      <PageTitle
        title="Templates"
        button={
          <Button
            variant="contained"
            size="small"
            color="primary"
            aria-describedby={id}
            onClick={(event) => {
              setGetTamplateId(null);
              setPopoverEvent(event.currentTarget);
              setPopoverDeps(true);
            }}
          >
            Create Template
          </Button>
        }
      />
      <Grid
        container
        spacing={3}
        style={{ padding: "0 30px 30px", overflowY: "auto", height: "75vh" }}
      >
        {templateList.length > 0 ? (
          templateList.map((value) => (
            <Grid key={value.temp_id} item xs={12} sm={4} md={3}>
              {value.template_name && (
                <TemplatesList
                  {...value}
                  setGetId={setGetTamplateId}
                  openModal={setOpenModal}
                />
              )}
            </Grid>
          ))
        ) : (
          <p style={{ marginTop: "20%", marginLeft: "45%" }}>No data found</p>
        )}
      </Grid>
      <DeleteModal
        open={openDeleteModal}
        setOpen={setOpenDeleteModal}
        setDone={setDeleteDone}
      />
      <TemplateModal
        open={openModal}
        setOpen={setOpenModal}
        setOpenDeleteModal={setOpenDeleteModal}
        setPopoverEvent={setPopoverEvent}
        setPopoverDeps={setPopoverDeps}
        setIsEdit={setIsEdit}
        id={id}
        title={
          templateList.length > 0 && getTamplateId != null
            ? templateList.find((val) => val.temp_id === getTamplateId)
                .template_name
            : null
        }
        data={
          templateList.length > 0 && getTamplateId != null
            ? templateList.find((val) => val.temp_id === getTamplateId)
                .template_body
            : null
        }
      />
      <UserPopover
        id={id}
        open={open}
        form={templateForm}
        setOpen={setPopoverDeps}
        popoverEvent={popoverEvent}
        anchorOrigin={{
          vertical: "top",
          horizontal: "right",
        }}
        transformOrigin={{
          vertical: "top",
          horizontal: "left",
        }}
      />
      <UserSnackbar
        severity={snackbarSeverity}
        open={openSnackbar}
        setClose={setOpenSnackbar}
        message={snackbarMsg}
      />
    </>
  );
}
